import { STATUS_LABELS, STATUS_COLORS, URGENCY_LABELS, URGENCY_COLORS, UNIT_STATUS_LABELS, UNIT_STATUS_COLORS } from "@/lib/constants";

export function StatusBadge({ status, "data-testid": testId }) {
    const label = STATUS_LABELS[status] || status;
    const color = STATUS_COLORS[status] || "fm-badge-neutral";
    return <span className={`fm-badge ${color}`} data-testid={testId}>{label}</span>;
}

export function UrgencyBadge({ urgency }) {
    const label = URGENCY_LABELS[urgency] || urgency;
    const color = URGENCY_COLORS[urgency] || "fm-badge-neutral";
    return <span className={`fm-badge ${color}`}>{label}</span>;
}

export function UnitStatusBadge({ status }) {
    const label = UNIT_STATUS_LABELS[status] || status;
    const color = UNIT_STATUS_COLORS[status] || "fm-badge-neutral";
    return <span className={`fm-badge ${color}`}>{label}</span>;
}
